$(function(){
    ACC.account.bindAll();

    if(!GSEB.constants.autocompleteRich) ACC.autocomplete.bindAll();
    ACC.recipe.autocomplete.bindAll();
    ACC.faq.autocomplete.bindAll();
    ACC.ifu.autocomplete.bindAll();
    // #BRA-9371
    //ACC.repairs.autocomplete.bindAll();
    //ACC.store.autocomplete.bindAll();
    ACC.reparability.autocomplete.bindAll();

    ACC.cartpopup.bindAll();

    ACC.cartremoveitem.bindAll();

    ACC.product.bindAll();

    ACC.userlocation.bindAll();
    
    ACC.addressgeocode.bindAll();
});

